<header class="topbar">
  <!-- ── Barra móvil (≤ 960px) ────────────────────────────────────────── -->
  <div class="topbar__mobile-bar">
    <button
      class="topbar__sidebar-btn"
      type="button"
      (click)="toggleSidebar()"
      aria-label="Abrir menú lateral"
    >
      <i class="pi pi-bars"></i>
    </button>
    <a class="topbar__mobile-brand" routerLink="/dashboard/overview">
      <img src="assets/images/logos/logo-light_small.png" alt="Sinergial" width="32" height="32" />
    </a>

    <app-internal-search />

    <div class="topbar__mobile-right">
      <!-- <app-notification-header-button
        [mobile]="true"
        [active]="notificationPanelOpen()"
        [unreadCount]="unreadNotifications()"
        (press)="toggleNotificationPanel()"
      /> -->

      <button
        class="topbar__toggle"
        type="button"
        (click)="toggleTheme()"
        aria-label="Cambiar tema"
      >
        @if (themeMode() === 'dark') {
          <span class="topbar__icon-svg" aria-hidden="true"><i class="pi pi-moon"></i></span>
        } @else {
          <span class="topbar__icon-svg" aria-hidden="true"><i class="pi pi-sun"></i></span>
        }
      </button>

      <div class="topbar__user">
        <button
          class="topbar__user-trigger"
          type="button"
          (click)="toggleUserMenu($event)"
          aria-label="Menú de usuario"
        >
          <span class="topbar__avatar">{{
            currentUser()?.nombre?.slice(0, 2)?.toUpperCase() || '?'
          }}</span>
        </button>
        @if (menuOpen()) {
          <div class="topbar__user-menu">
            <button class="topbar__user-item" type="button" (click)="openProfile()">
              Mi perfil
            </button>
            <button class="topbar__user-item" type="button" (click)="openConfiguracion()">
              Configuración
            </button>
            <button class="topbar__user-item" type="button" (click)="openNovedades()">
              Novedades
            </button>
            <button class="topbar__user-item" type="button" (click)="actualizarPermisos()">
              Actualizar permisos
            </button>
            <button class="topbar__user-item" type="button" (click)="openVerificarApi()">
              Verificar APIs
            </button>
            <div class="topbar__user-divider"></div>
            <button class="topbar__user-item" type="button" (click)="openCentroSoporte()">
              Centro de soporte
            </button>
            <button class="topbar__user-item" type="button" (click)="openAbout()">Acerca de</button>
            <div class="topbar__user-divider"></div>
            <button
              class="topbar__user-item topbar__user-item--danger"
              type="button"
              (click)="logout()"
            >
              Cerrar sesión
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- ── Escritorio izquierda (> 960px) ──────────────────────────────── -->
  <div class="topbar__left">
    <a class="topbar__brand-link" routerLink="/dashboard/overview">
      <img class="topbar__logo" src="assets/images/logo-light.png" alt="Sinergial Advance" />
    </a>
    <div class="topbar__search-wrap">
      <app-internal-search />
    </div>
  </div>

  <!-- ── Escritorio derecha (> 960px) ───────────────────────────────── -->
  <div class="topbar__right">
    <!-- <app-notification-header-button
      [active]="notificationPanelOpen()"
      [unreadCount]="unreadNotifications()"
      (press)="toggleNotificationPanel()"
    /> -->

    <button class="topbar__toggle" type="button" (click)="toggleTheme()" aria-label="Cambiar tema">
      @if (themeMode() === 'dark') {
        <span class="topbar__icon-svg" aria-hidden="true"><i class="pi pi-moon"></i></span>
      } @else {
        <span class="topbar__icon-svg" aria-hidden="true"><i class="pi pi-sun"></i></span>
      }
    </button>

    <div class="topbar__user">
      <button class="topbar__user-trigger" type="button" (click)="toggleUserMenu($event)">
        <span class="topbar__avatar">{{
          currentUser()?.nombre?.slice(0, 2)?.toUpperCase() || '?'
        }}</span>
        {{ currentUser()?.nombre || 'Usuario' }}
        <span class="topbar__caret">▾</span>
      </button>
      @if (menuOpen()) {
        <div class="topbar__user-menu">
          <button class="topbar__user-item" type="button" (click)="openProfile()">Mi perfil</button>
          <button class="topbar__user-item" type="button" (click)="openConfiguracion()">
            Configuración
          </button>
          <button class="topbar__user-item" type="button" (click)="openNovedades()">
            Novedades
          </button>
          <button class="topbar__user-item" type="button" (click)="actualizarPermisos()">
            Actualizar permisos
          </button>
          <button class="topbar__user-item" type="button" (click)="openVerificarApi()">
            Verificar APIs
          </button>
          <div class="topbar__user-divider"></div>
          <button class="topbar__user-item" type="button" (click)="openCentroSoporte()">
            Centro de soporte
          </button>
          <button class="topbar__user-item" type="button" (click)="openAbout()">Acerca de</button>
          <div class="topbar__user-divider"></div>
          <button
            class="topbar__user-item topbar__user-item--danger"
            type="button"
            (click)="logout()"
          >
            Cerrar sesión
          </button>
        </div>
      }
    </div>
  </div>
</header>

<app-notification-panel
  [open]="notificationPanelOpen()"
  [notifications]="notifications()"
  [state]="notificationsState()"
  [errorMessage]="notificationsError()"
  [unreadCount]="unreadNotifications()"
  [loadingMore]="notificationsLoadingMore()"
  [hasMore]="notificationsHasMore()"
  (close)="closeNotificationPanel()"
  (retry)="retryNotificationsLoad()"
  (selectNotification)="openNotification($event)"
  (loadMore)="loadMoreNotifications()"
/>

<app-about-dialog [(visible)]="aboutVisible" />
<app-verificar-api [(open)]="verificarApiVisible" />
